module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/d4f362370d76c864bc6d4e608358f9a3.png";